import {Navigate, Routes, Route, Outlet, useLocation, useNavigate} from 'react-router-dom'
import {NavigationProps, NavItem} from './NavigationTypes'
import {NavigationTabs} from './components/NavigationTabs'
import NavigationTitle from './components/NavigationTitle'

const Navigation = ({
  id,
  navigationData,
  baseUrl,
  className = '',
  defaultKey = navigationData?.[0]?.key,
  breadcrumbs = false,
  isLoading,
  pageTitle,
  pageTitleComponent,
  paramKey = 'view',
  viewSingleComponent = navigationData?.length === 1 ? false : true,
  disableSearchParams = false,
  hideNavigation = false,
  searchParams = {},
  onChange = () => {},
}: NavigationProps) => {
  const location = useLocation()
  const NavigateToPath = useNavigate()
  const visibleNavigationData = navigationData.filter((item) => item.show !== false)

  const dynamicRoutings = () => {
    if (disableSearchParams || !viewSingleComponent) {
      return (
        <Routes>
          <Route
            element={
              <>
                <Outlet />
              </>
            }
          >
            {visibleNavigationData.map((item) => (
              <Route
                key={item.key}
                path={!viewSingleComponent ? '/' : `${item.key}`}
                element={
                  <>
                    <NavigationTitle
                      breadcrumbs={item.breadcrumbs}
                      disableBreadCrumbs={item.disableBreadCrumbs}
                      defaultBreadcrumbs={breadcrumbs}
                      isLoading={isLoading}
                      pageTitleComponent={pageTitleComponent}
                      title={
                        item?.title === true || item?.title === undefined
                          ? pageTitle === true
                            ? item?.label
                            : typeof pageTitle === 'string'
                            ? pageTitle
                            : pageTitle === false
                            ? false
                            : item?.label
                          : typeof item?.title === 'string'
                          ? item?.title
                          : false
                      }
                    />
                    {item.component}
                  </>
                }
              />
            ))}

            {viewSingleComponent && (
              <Route index element={<Navigate to={`${baseUrl}/${defaultKey}`} replace />} />
            )}
          </Route>
        </Routes>
      )
    } else {
      const allParams = Object.fromEntries(new URLSearchParams(location.search).entries())
      const activeView = allParams?.[paramKey] || null
      const isValidView = visibleNavigationData.some((item) => item.key === activeView)
      const activeSearchComponent: NavItem | undefined = !disableSearchParams
        ? isValidView
          ? visibleNavigationData.find((item) => item.key === activeView)
          : visibleNavigationData.find((item) => item.key === defaultKey)
        : undefined

      const mergedParams = Object.entries({
        ...allParams,
        ...(activeSearchComponent?.searchParams || searchParams || {}),
        [paramKey]: isValidView ? activeView : defaultKey,
      }).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value.toString()
        }
        return acc
      }, {} as Record<string, string>)

      const expectedPath = `${baseUrl}?${new URLSearchParams(mergedParams).toString()}`

      if (location.pathname === baseUrl && !isValidView) {
        NavigateToPath(expectedPath)
      }

      return (
        <>
          <NavigationTitle
            breadcrumbs={activeSearchComponent?.breadcrumbs}
            disableBreadCrumbs={activeSearchComponent?.disableBreadCrumbs}
            defaultBreadcrumbs={breadcrumbs}
            isLoading={isLoading}
            pageTitleComponent={pageTitleComponent}
            title={
              activeSearchComponent?.title === true || activeSearchComponent?.title === undefined
                ? pageTitle === true
                  ? activeSearchComponent?.label
                  : typeof pageTitle === 'string'
                  ? pageTitle
                  : pageTitle === false
                  ? false
                  : activeSearchComponent?.label
                : typeof activeSearchComponent?.title === 'string'
                ? activeSearchComponent?.title
                : false
            }
          />
          <Navigate
            to={!isValidView ? expectedPath : window.location.pathname + window.location.search}
            replace
          />
          {activeSearchComponent?.component}
        </>
      )
    }
  }

  return (
    <>
      {!hideNavigation && viewSingleComponent && (
        <NavigationTabs
          id={id}
          navigations={visibleNavigationData}
          disableSearchParams={disableSearchParams}
          className={className}
          baseUrl={baseUrl}
          paramKey={paramKey}
          searchParams={searchParams}
          onChange={onChange}
        />
      )}
      {dynamicRoutings()}
    </>
  )
}

export default Navigation
